import { createSlice } from '@reduxjs/toolkit';

import { TRootState } from '../../../../../store';

export type TTasksPaneTypes =
    | 'Task'
    | 'ContractItem'
    | 'Contract'
    | 'Client'
    | 'Location';

export const DEFAULT_TASK_PANE: TTasksPaneTypes = 'Task';

interface IState {
    selectedPane: null | TTasksPaneTypes;
}

export const initialState: IState = {
    selectedPane: DEFAULT_TASK_PANE,
};

const tasksPane = createSlice({
    name: 'tasksPane',
    initialState,
    reducers: {
        selectPane(state, action: { payload: TTasksPaneTypes; type: string }) {
            state.selectedPane = action.payload;
        },
        closePane(state) {
            state.selectedPane = initialState.selectedPane;
        },
    },
});

const getCurrent = (state: TRootState) =>
    state.ui.customerService.tasksPane as IState;

export const getSelectedPane = (state: TRootState) =>
    getCurrent(state).selectedPane;

export const { closePane, selectPane } = tasksPane.actions;

export default tasksPane.reducer;
